import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HomeData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HomeDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HomeDataStore",
			variables: false,
		})
	}
}

export async function load_HomeData(params) {
  await initClient()

	const store = new HomeDataStore()

	await store.fetch(params)

	return {
		HomeData: store,
	}
}
